export function sendMessageToParentFrame(
  message: Record<string, unknown>,
  targetOrigin: string = '*',
): boolean {
  try {
    if (window?.parent && window.parent !== window) {
      window.parent.postMessage(
        {
          ...message,
          source: 'antimatter-client',
        },
        targetOrigin,
      );
      return true;
    }
    return false;
  } catch (error) {
    console.error('Failed to send message to parent:', error);
    return false;
  }
}
